import { createFileRoute, redirect } from "@tanstack/react-router";

// The per-farm dashboard was consolidated into the scope-aware Grass Production
// hub. Redirect this legacy URL onto the hub with the farm preselected via
// `?farm=`, which leaves the farm-intrinsic path entirely (no path↔param desync,
// so no redirect loop — see the farm-scope gotcha in the package CLAUDE.md).
export const Route = createFileRoute(
	"/_auth/app/_app/org/$orgId/grass-production/farms/$farmId/",
)({
	// Pure redirect onto the (offline-ready) hub — safe offline.
	staticData: { offline: "ready" },
	beforeLoad: ({ params }) => {
		throw redirect({
			to: "/app/org/$orgId/grass-production",
			params: { orgId: params.orgId },
			search: { farm: params.farmId },
		});
	},
});
